module.exports = __webpack_public_path__ + "img/cmfg3.5d957e2e.jpg";